import "./company.css";

import React from "react";

import { COMPANY_STATEMENT } from "../../data/content";
import PageMeta from "../general/PageMeta";

//Line icons for the four blocks (drawn to match the original site's icons)
const ICONS = {
  approach: (
    <svg viewBox={"0 0 48 48"}>
      <rect
        x={"9"}
        y={"5"}
        width={"26"}
        height={"36"}
        rx={"3"}
      />
      <path d={"M15 5v36M20 14h9M20 20h11M20 26h11M20 32h8M35 12h4v30H15"} />
    </svg>
  ),
  vision: (
    <svg viewBox={"0 0 48 48"}>
      <path d={"M3 24s8-13 21-13 21 13 21 13-8 13-21 13S3 24 3 24z"} />
      <circle
        cx={"24"}
        cy={"24"}
        r={"7"}
      />
      <circle
        cx={"24"}
        cy={"24"}
        r={"2.5"}
        className={"is-filled"}
      />
    </svg>
  ),
  mission: (
    <svg viewBox={"0 0 48 48"}>
      <path
        d={"M4 40h40V8H34v8h-8v8h-8v8h-8v8z"}
        className={"is-filled"}
      />
    </svg>
  ),
  philosophy: (
    <svg viewBox={"0 0 48 48"}>
      <path d={"M2 18l8-6 8 3 6-3 6 3 8-3 8 6-6 9-10 9c-1.5 1.3-3.5 1.3-5 0L6 27z"} />
      <path d={"M18 15l-4 6c-1 2 2 4 4 2l4-4 10 9M26 32l-4-4M22 35l-4-4"} />
    </svg>
  ),
};

const CompanyStatement = () => {
  return (
    <section
      className={"company-page"}
      style={{ backgroundImage: "url(/images/pages/company-statement.webp)" }}
    >
      <PageMeta title={"Company Statement"} />

      <div className={"company-intro"}>
        <div className={"container"}>
          <h1 className={"company-title"}>
            about <span className={"company-title-u"}>U</span> financial advisors
          </h1>
          <span className={"title-rule"} />
          <p>{COMPANY_STATEMENT.INTRO}</p>
          <p>{COMPANY_STATEMENT.PROMISE}</p>
          <p className={"company-pillars"}>
            {COMPANY_STATEMENT.PILLARS.map((pillar, i) => (
              <React.Fragment key={pillar}>
                {i > 0 ? <span className={"company-pillar-sep"}> I </span> : null}
                <span>{pillar}</span>
              </React.Fragment>
            ))}
          </p>
        </div>
      </div>

      <div className={"company-blocks"}>
        {COMPANY_STATEMENT.BLOCKS.map((block) => (
          <article
            key={block.title}
            className={`company-block ${block.isDark ? "is-dark" : ""}`}
          >
            <span
              className={`company-icon is-${block.icon}`}
              aria-hidden={"true"}
            >
              {ICONS[block.icon]}
            </span>
            <h2 className={"company-block-title"}>{block.title}</h2>
            {block.text.map((paragraph) => (
              <p key={paragraph.slice(0, 20)}>{paragraph}</p>
            ))}
          </article>
        ))}
      </div>
    </section>
  );
};

export default CompanyStatement;
